export default __webpack_public_path__ + "static/media/jr.49bf6c60.png";